// ** redux imports
import { createSlice } from '@reduxjs/toolkit';

// initial states
const initialState = {};

export const announcementSlice = createSlice({
  name: 'announcement',
  initialState,
  reducers: {},
});

export const {} = announcementSlice.actions;

export default announcementSlice.reducer;
